<!-- eslint-disable max-len -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat outlined>
      <v-btn icon :link="false" @click="back">
        <v-icon>fa-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Detalles del Vehículo</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-md fluid >
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Vehículo</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field  class="my-0 py-0"
            v-model = "vehiculo_info.marca"
            label="Marca"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model = "vehiculo_info.modelo"
            label="Modelo"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="vehiculo_info.anio"
            label="Año"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="vehiculo_info.color"
            label="Color"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="vehiculo_info.placas"
            label="Placas"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="vehiculo_info.num_serie"
            label="Número de Serie"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="vehiculo_info.num_tag"
            label="Número de Tag"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-textarea class="my-0 py-0"
            v-model="vehiculo_info.observaciones"
            label="Observaciones"
            :value="vehiculo_info.observaciones"
            no-resize
            rows="1"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Conductor(es)</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm12 md12>
          <template v-for="(conductor, index) in vehiculo_info.asignaciones">
            <v-layout row wrap :key="index">
              <v-flex xs12 sm2 md3>
                <v-text-field class="my-0 py-0"
                  label="Tipo"
                  v-model="conductor.tipo_name"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field class="my-0 py-0"
                  label="Vivienda"
                  v-model="conductor.n_vivienda"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm5 md5>
                <v-text-field class="my-0 py-0"
                  label="Conductor"
                  v-model="conductor.conductor_fullname"
                  readonly
                />
              </v-flex>
            </v-layout>
          </template>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Multimedia</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <label>Vehículo</label>
          <img :src="decode_base64('foto')" style="width: 100%" alt="Vehículo"/>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <label>Vehículo</label>
          <img :src="decode_base64('foto_alt')" style="width: 100%" alt="Vehículo"/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({
    vehiculo_info: {},
    conductores_asociados: [],
  }),
  computed: {
    is_loading() {
      return this.$store.getters['detallesVehiculo/is_loading'];
    },
    vehiculo_processing() {
      return this.$store.getters['detallesVehiculo/vehiculo_processing'];
    },
  },
  watch: {
  },
  methods: {
    back() {
      this.$router.back();
    },
    decode_base64(type, value) {
      let encoded = '';
      let extension = '';
      if (type === 'foto') {
        encoded = this.vehiculo_info.foto;
      } else if (type === 'foto_alt') {
        encoded = this.vehiculo_info.foto_alt;
      } else {
        encoded = value;
      }
      if (typeof encoded === 'string') {
        const check = encoded.substring(0, 3);
        if (check === '/9j') {
          extension = 'jpg';
        } else if (check === 'iVB') {
          extension = 'png';
        } else if (check === 'SUk') {
          extension = 'tiff';
        } else extension = 'bmp'; // Qk0
      } else {
        extension = 'png';
        encoded = 'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
    set_tipo_name(tipo) {
      this.tipo_name = '';
      this.tipo = tipo;
      if (tipo === 'residente') {
        this.tipo_name = 'Residente';
      } else if (tipo === 'servicio_domestico') {
        this.tipo_name = 'Servicio Doméstico';
      }
    },
    conductores_asociados_info(conductores) {
      let i;
      for (i = 0; i < conductores.length; i++) {
        if (conductores[i].tipo === 'residente') {
          this.tmpConductorId = conductores[i].residente_id;
        } else {
          this.tmpConductorId = conductores[i].domestico_id;
        }
        this.tmpComductorFullname = `${this.clear_null(conductores[i].nombre)} ${this.clear_null(conductores[i].apellidos)}`.trim();
        this.set_tipo_name(conductores[i].tipo);
        const formdata = {
          vivienda_id: conductores[i].vivienda_id,
          n_vivienda: conductores[i].vivienda_n,
          conductor_id: this.tmpConductorId,
          conductor_fullname: this.tmpComductorFullname,
          tipo_name: this.tipo_name,
          tipo: conductores[i].tipo,
        };
        this.conductores_asociados.push(formdata);
      }
      this.vehiculo_info.asignaciones = this.conductores_asociados;
    },
  },
  created() {

  },
  mounted() {
    this.$store.dispatch('detallesVehiculo/fetchVehiculoInfo', this.$route.params.id)
      .then((data) => {
        this.vehiculo_info = data.vehiculo;
        this.conductores_asociados_info(this.vehiculo_info.asignaciones);
        console.log(this.vehiculo_info);
      });
  },
};
</script>
